module.exports = __webpack_public_path__ + "static/media/5.ico.c1a2056e.png";